<template>
    <!-- ========== BLOG ========== -->
    <section id="blog">
        <div class="container">
            <div class="main_title mt_wave a_center">
                <h2>ÚLTIMAS NOTICIAS</h2>
            </div>
            <p class="main_description a_center">Entérate de las útlimas novedades y eventos que tenemos para ti.</p>

            <div class="row">
                <!-- ITEM -->
                <item-blog></item-blog>
                <!-- ITEM -->
                <item-blog></item-blog>
                <!-- ITEM -->
                <item-blog></item-blog>
                <!-- ITEM -->
                <item-blog></item-blog>
            </div>
        </div>
    </section>
</template>
<script>
    import Item from './Item.vue';
    export default {
        components : {
            'item-blog' : Item
        },
        created : function(){
            var self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                self.$language = self.$store.state.language;
            });
        },
        beforeDestroy : function(){
            this.unsubscribe();
        }
    };
</script>


// WEBPACK FOOTER //
// Blog.vue?16333e6d